"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }/* Picking a template inserts its latest version: a teammate may have edited
 * or deleted it since the picker loaded the list. */


var _messageTemplate = require('shared/actions/messageTemplate'); var _messageTemplate2 = _interopRequireDefault(_messageTemplate);
var _log = require('shared/log');














/* Fetches the template's latest version and says how it compares with the one
 * shown. Never throws. */
 const fetchLatestTemplate = async (orgKey, shown) => {
  try {
    const { Template, Deleted } = await _messageTemplate2.default.getMessageTemplate(orgKey, shown.TemplateKey, shown.UpdatedAt)
    if (Deleted || !Template) return { kind: 'deleted' }
    const changed = Template.UpdatedAt !== shown.UpdatedAt || Template.Body !== shown.Body
    return changed ? { kind: 'updated', template: Template } : { kind: 'same', template: Template }
  } catch (e) {
    if (e instanceof _log.CommandError && e.Error === 'unauthorized command') {
      // Its sharing changed since the list loaded: drop the stale row.
      _messageTemplate2.default.listMessageTemplates(orgKey).catch(() => null)
      return { kind: 'unavailable' }
    }
    log.info('Couldn\'t fetch the latest version of a template; inserting the one shown', e)
    return { kind: 'failed', template: shown }
  }
}; exports.fetchLatestTemplate = fetchLatestTemplate
